import React from 'react'

import { IMG } from '../../../../themes'

const EditIcon = ({ selectedBooking, permission, onUpdate }) => {
  const hasPermission = permission.update && selectedBooking && selectedBooking.status !== 0

  return (
    <img
      src={IMG[`ic_edit_${hasPermission ? 'black' : 'gray'}.svg`]}
      style={{ cursor: hasPermission ? 'pointer' : 'not-allowed' }}
      alt='edit'
      onClick={hasPermission ? () => onUpdate(selectedBooking.id) : null} 
    />
  )
}

export default EditIcon
